export class MongoAtlasRestoreAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "apiPublicKey",
            "baseName": "apiPublicKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "apiPrivateKey",
            "baseName": "apiPrivateKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "atlasProjectId",
            "baseName": "atlasProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "awsRestoreAccountId",
            "baseName": "awsRestoreAccountId",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MongoAtlasRestoreAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
